export default __webpack_public_path__ + "static/media/blog-driveway-size-002.ced7b691.jpg";